import { render, staticRenderFns } from "./WaterSettings.vue?vue&type=template&id=3229f93e&"
import script from "./WaterSettings.vue?vue&type=script&lang=js&"
export * from "./WaterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports